import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PolicyUnderwriterColumns, PolicyUnderwriterRow } from '../../../models/Policy';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { BehaviorSubject } from 'rxjs';
import { PriceRangeModalComponent } from '../../../../price-rates/components/price-range-modal/price-range-modal.component';
import { DataTableComponent } from '../../../../../shared/components/data-table/data-table.component';

@Component({
  selector: 'app-policy-underwriters',
  templateUrl: './policy-underwriters.component.html',
  styleUrls: ['./policy-underwriters.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCard,
    DataTableComponent
  ]
})
export class PolicyUnderwritersComponent implements OnInit {

  @Input() policyUnderwriterDatasource!: any;
  @Output() openEditUnderwriterDialog: EventEmitter<any> = new EventEmitter();
  @Output() openDeleteUnderwriterDialog: EventEmitter<any> = new EventEmitter();

  loading = new BehaviorSubject<boolean>(false);
  dataSource = new MatTableDataSource<PolicyUnderwriterRow>();
  displayedColumns = PolicyUnderwriterColumns;

  constructor(private dialog: MatDialog) {}

  ngOnInit() {
    this.dataSource = this.policyUnderwriterDatasource;
  }

  onEditUnderwriterActionClick(row: any) {
    this.openEditUnderwriterDialog.emit(row);
  }

  onDeleteUnderwriterActionClick(row: any) {
    this.openDeleteUnderwriterDialog.emit(row);
  }

  onViewRangesOpenClick(row: any) {
    this.dialog.open(PriceRangeModalComponent, {
      width: '70%',
      data: { row }
    });
  }
}